import R from 'ramda';
import { toID } from './utils';
import { ACTIONS } from '../const';
import objectRecord from './object_record';

const termRecord = objectRecord({
    created: null,
    end_date: null,
    id: null,
    modified: null,
    name: null,
    resource_uri: null,
    sections: [],
    section_ids: [],
    sis_term_uid: null,
    start_date: null,
});

const stateRecord = objectRecord({
    user_terms: [],
    terms: {},
});

const defaultState = stateRecord();

const sectionIds = R.compose(
    R.uniq,
    R.map(toID),
    R.path(['payload', 'sections'])
);

const userTerms = R.compose(R.uniq, R.map(toID), R.path(['user', 'terms']));

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case ACTIONS.SYNC_USER:
            return {
                ...state,
                user_terms: userTerms(action),
            };
        case ACTIONS.SYNC_TERM: {
            const { payload } = action;
            const newTerm = new termRecord(payload, {
                id: parseInt(payload.id, 10),
                section_ids: sectionIds(action),
            });

            const terms = {
                ...state.terms,
                [newTerm.id]: newTerm,
            };

            return {
                ...state,
                terms,
            };
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/terms.js